import { DataGrid } from '@mui/x-data-grid';

export const LogUsageTable = ({rows, columns, selectedRow, onRowSelection}) => {
    return (
        <div style={{ height: 400, width: '100%' }}>
            <DataGrid
                rows={rows}
                columns={columns}
                selectedRow={selectedRow}
                onRowSelectionModelChange={onRowSelection}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 5 },
                    },
                }}
                pageSizeOptions={[5, 10]}
            />
        </div>
    )
};